<template>
  <v-row justify="center">
    <v-dialog v-model="show" persistent max-width="60%">
      <custom-modal
        title="Create Rate Type"
        @onSubmit="submit"
        @onClose="onClose()"
        :isLoading="isLoading"
      >
        <ValidationObserver ref="observer" v-slot="{ validate, reset }">
          <v-row>
            <v-col cols="4">
              <v-row>
                <v-col cols="12">
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="Rate Type"
                    rules="required"
                    vid="name"
                  >
                    <v-text-field
                      outlined
                    
                      v-model="rateType.name"
                      :error-messages="errors"
                      dense
                      hide-details="auto"
                      label="Rate Type"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                   </v-row>
                <v-row>
                <v-col cols="12">
                   <ValidationProvider
                    v-slot="{ errors }"
                    name="Code"
                    rules="required"
                    vid="code"
                  >
                    <v-text-field
                      v-model="rateType.code"
                      :error-messages="errors"
                      outlined
                      dense
                      hide-details="auto"
                      label="Code"
                      
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                </v-row>
            <v-row>
                <v-col cols="12">
                  <ValidationProvider
                    name="code"
                    rules="required"
                    v-slot="{ errors }"
                    vid="code"
                  >
                    <v-checkbox
                    v-model="rateType.is_package"
                    label="isPackage"
                  ></v-checkbox>
                  </ValidationProvider>
                </v-col>
                </v-row>
           
            </v-col>
            <v-col cols="8">
              <v-row>
                <v-col cols="12" class="pt-0">
                  <v-card-title class="px-0 pt-0">Room Types</v-card-title>

                   <v-data-table
                        :headers="headers"
                         height="400"
                        :items="roomTypes"
                        hide-default-footer
                         v-model="rateType.roomTypes"
                        disable-pagination
                        show-select
                          fixed-header
                         class="elevation-1"
                      >
                   
                        <template
                          v-slot:item.track_rate="{ item }"
                          v-slot="{ errors }"
                          name="Damage"
                          rules="numeric"
                        ><div class="boxes">
                          <ValidationProvider>
                            <v-text-field
                              @input="ValidateTableInputs(item)"
                              v-model="item.rack_rate"
                              :error-messages="item.rack_rate_error"
                              required
                              dense
                              class="pt-3"
                               type="number"
                              outlined
                              min="0"
                            ></v-text-field>
                          </ValidationProvider>
                          </div>
                        </template>
                        <template
                          v-slot:item.extra_adult="{ item }"

                          v-slot="{ errors }"
                          name="Damage"
                          rules="numeric"
                        ><div class="boxes">
                          <ValidationProvider>
                            <v-text-field
                              @input="ValidateTableInputs(item)"
                              v-model="item.extra_adult"
                              :error-messages="item.extra_adult_error"
                              required
                              dense
                               type="number"
                              class="pt-3"
                              outlined
                              min="0"
                            ></v-text-field>
                          </ValidationProvider>
                          </div>
                        </template>
                        <template
                          v-slot:item.extra_child="{ item }"

                          v-slot="{ errors }"
                          name="Damage"
                          rules="numeric"
                        ><div class="boxes">
                          <ValidationProvider>
                            <v-text-field
                              @input="ValidateTableInputs(item)"
                              v-model="item.extra_child"
                              :error-messages="item.extra_child_error"
                              required
                               type="number"
                              dense
                              class="pt-3"
                              outlined
                              min="0"
                            ></v-text-field>
                          </ValidationProvider>
                          </div>
                        </template>
                   </v-data-table>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </ValidationObserver>
      </custom-modal>
    </v-dialog>
  </v-row>
</template>

<script>
import { Payment } from "@/models/Payment";
import datePickComponent from "@/components/base/DateComponent";
import FileUpload from "@/components/base/FileUpload";
import { required, numeric } from "vee-validate/dist/rules";
import axios from "@/plugins/axios";

import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
import { RateType } from "../../../models/RateType";
import ColorPicker from "../../../components/base/ColorPicker.vue";
extend("required", {
  ...required,
  message: "{_field_} is required",
});
extend("numeric", {
  ...numeric,
  message: "input must be numeric",
});
extend("max", {
  ...numeric,
  message: "amount must be less than balance",
});
export default {
  data: () => ({
    rateType: new RateType(),
    dialog: false,
    show: false,
    selectedFiles: [],
    roomTypes: [],
        headers: [
      {
        text: "Name",
        value: "name",
      },
      {
        text: "Max Adult",
        value: "max_adult",
      },
  {
        text: "Track Rate",
        value: "track_rate",
      },
      {
        text: "Extra Adult",
        value: "extra_adult",
      },
      {
        text: "Extra Child",
        value: "extra_child",
      },

   
    ],
  }),

  name: "AddBatch",
  updated: function () {},
  props: {
    creditAccounts: {
      type: Array,
      default: [],
    },
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    datePickComponent,
    FileUpload,
  },
  computed: {},
  methods: {
    openModal() {
      
      this.show = true;
      this.GetRoomTypes();
    },
    async submit() {
   
     
      const isValid = await this.$refs.observer.validate();
      let error=false;
      
       this.rateType.roomTypes.map(p=>{
         if( !p.rack_rate || p.rack_rate<=0){
            error=true;
            p.rack_rate_error=[];
            p.rack_rate_error.push('rate should be greater than zero');
         }
         if(!p.extra_adult ||p.extra_adult<=0)
         {
            error=true;
            p.extra_adult_error=[];
            p.extra_adult_error.push('rate should be greater than zero');
         }
          if(!p.extra_child || p.extra_child<=0)
          {
            error=true;
            p.extra_child_error=[];
            p.extra_child_error.push('rate should be greater than zero');
          }
       })
      if (isValid && !error) {

        this.createRateType();
      }
    },
    ValidateTableInputs(p)
          {
          
          if( p.rack_rate || p.rack_rate>=0){
                      p.rack_rate_error=[];
                  }
                  if(p.extra_adult ||p.extra_adult>=0)
                  {
                      p.extra_adult_error=[];
                     
                  }
                    if(p.extra_child || p.extra_child>=0)
                    {
                      p.extra_child_error=[];
                    
                    }
          } 

,   GetRoomTypes() {
      axios
        .get(`hms/room-types`)
        .then((res) => {
          
          this.roomTypes = res.data.data;
        })
        .catch((err) => {});
    },
    createRateType() {
      axios
        .post(`hms/rate-types`, this.rateType.toRequestModel())
        .then((res) => {
          this.$emit("afterSave", true);
          this.show = false;
          this.rateType = new RateType();
          this.$toast.success("Price type created successfully");
        })
        .catch((err) => {
          
          console.log(err);
          this.$refs.observer.setErrors(err.response.data.error);
        });
    },
    onClose() {
      this.show = false;
      this.rateType = new RateType();
    },
  },
  created() {
   
  },
};
</script>

<style scoped>
.amenties-list {
  overflow-y: scroll;
  height: 350px;
}
</style>
